import { useReducer } from 'react';
import { customTableReducer } from '../../../../../hooks/tableHook';
import { DC } from './variables';

export const useParcelEvaluationReducer = ({
  initialSearchParams,
  resetSearchParams,
}) => {
  const [searchParams, dispatch] = useReducer(
    customTableReducer({ resetSearchParams, customReducer }),
    initialSearchParams
  );
  return [searchParams, dispatch];
};

const customReducer = (state, { type, payload }) => {
  switch (type) {
    case DC.RISK_TYPE:
    case DC.REVIEW_STATUS:
    case DC.PRODUCT_STATUS:
    case DC.BRAND:
    case DC.PRODUCT_CATEGORY:
    case DC.LOCATION:
      return {
        ...state,
        [type]: [...payload],
        [DC.FILTERS_SET]: true,
      };
    default:
      return state;
  }
};
